"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Position = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var react_2 = require("react");
var Styled = __importStar(require("./ModalWrapper.styled"));
var components_1 = require("@/components");
var Button_component_1 = require("@/components/common/Button/Button.component");
var popup_close_44_svg_1 = __importDefault(require("@/assets/svg/popup-close-44.svg"));
exports.Position = {
    left: 'flex-start',
    center: 'center',
    right: 'flex-end',
};
var MAIN_ID = 'root';
var ModalWrapper = function (_a) {
    var className = _a.className, children = _a.children, heading = _a.heading, _b = _a.closeButtonHidden, closeButtonHidden = _b === void 0 ? false : _b, footer = _a.footer, handleCloseModal = _a.handleCloseModal, _c = _a.closeOnClickOverlay, closeOnClickOverlay = _c === void 0 ? true : _c, beforeRef = _a.beforeRef, _d = _a.isContentScroll, isContentScroll = _d === void 0 ? true : _d;
    var dialogRef = (0, react_2.useRef)(null);
    (0, react_2.useEffect)(function () {
        var _a;
        var $rootNode = document.getElementById(MAIN_ID);
        $rootNode === null || $rootNode === void 0 ? void 0 : $rootNode.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = 'hidden';
        var handleModalCloseWithEscHandler = function (_a) {
            var key = _a.key;
            var scheduledAnimationFrame = false;
            if (scheduledAnimationFrame) {
                return;
            }
            scheduledAnimationFrame = true;
            if (key === 'Escape') {
                handleCloseModal();
                scheduledAnimationFrame = false;
            }
        };
        window.addEventListener('keyup', handleModalCloseWithEscHandler);
        var handleFocusTrap = function (e) {
            var _a;
            var focusableNodeList = (_a = dialogRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('input, button, textarea, select, [href] [tabindex]');
            if (focusableNodeList) {
                var firstFocusableNode = focusableNodeList[0];
                var lastFocusableNode = focusableNodeList[focusableNodeList.length - 1];
                if (e.target === firstFocusableNode && e.shiftKey && e.key === 'Tab') {
                    e.preventDefault();
                    lastFocusableNode.focus();
                }
                if (e.target === lastFocusableNode && !e.shiftKey && e.key === 'Tab') {
                    e.preventDefault();
                    firstFocusableNode.focus();
                }
            }
        };
        (_a = dialogRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        window.addEventListener('keydown', handleFocusTrap);
        var beforeRefSnapshot = beforeRef;
        return function () {
            $rootNode === null || $rootNode === void 0 ? void 0 : $rootNode.removeAttribute('aria-hidden');
            document.body.style.overflow = 'unset';
            window.removeEventListener('keyup', handleModalCloseWithEscHandler);
            window.removeEventListener('keydown', handleFocusTrap);
            beforeRefSnapshot === null || beforeRefSnapshot === void 0 ? void 0 : beforeRefSnapshot.current.focus();
        };
    }, [beforeRef, handleCloseModal]);
    return ((0, jsx_runtime_1.jsx)(react_2.Suspense, __assign({ fallback: null }, { children: (0, jsx_runtime_1.jsx)(components_1.Portal, { children: (0, jsx_runtime_1.jsx)(Styled.Overlay, __assign({ onClick: function (e) {
                    if (e.target === e.currentTarget && closeOnClickOverlay) {
                        handleCloseModal();
                    }
                }, tabIndex: -1 }, { children: (0, jsx_runtime_1.jsxs)(Styled.ModalCard, __assign({ ref: dialogRef, className: className }, { children: [heading && ((0, jsx_runtime_1.jsx)(Styled.ModalHeader, { children: (0, jsx_runtime_1.jsx)("h2", { children: heading }, void 0) }, void 0)), (0, jsx_runtime_1.jsx)(Styled.ModalContent, __assign({ isContentScroll: isContentScroll }, { children: children }), void 0), footer && ((0, jsx_runtime_1.jsxs)(Styled.ModalFooter, __assign({ position: footer.position || exports.Position.right }, { children: [(footer === null || footer === void 0 ? void 0 : footer.cancelButton) && ((0, jsx_runtime_1.jsx)(components_1.Button, __assign({ "$size": Button_component_1.ButtonSize.sm, shape: Button_component_1.ButtonShape.defaultLine }, footer.cancelButton, { onClick: footer.cancelButton.onClick
                                        ? footer.cancelButton.onClick
                                        : function () { return handleCloseModal(); } }), void 0)), (footer === null || footer === void 0 ? void 0 : footer.confirmButton) && ((0, jsx_runtime_1.jsx)(components_1.Button, __assign({ "$size": Button_component_1.ButtonSize.sm, shape: Button_component_1.ButtonShape.primary }, footer.confirmButton), void 0))] }), void 0)), heading && !closeButtonHidden && ((0, jsx_runtime_1.jsx)(components_1.Button, { Icon: popup_close_44_svg_1.default, shape: Button_component_1.ButtonShape.icon, onClick: function () { return handleCloseModal(); } }, void 0))] }), void 0) }), void 0) }, void 0) }), void 0));
};
exports.default = ModalWrapper;
